module.exports = __webpack_public_path__ + "img/ai_history_mode.34bfd8d.png";